import React from 'react';
import PropTypes from 'prop-types';
import 'react-toggle/style.css';
import {Button, buttonTypes} from '../../../../components/Button/index';
import Input from '../../../../components/Input/index';
import {validationCustomerRegister} from '../../../../utils/validationUtils';

class Register extends React.Component {
  state = {
    isError: false,
    error: {},
    email: '',
    name: '',
    phone: '',
    lastName: '',
    companyName: '',
    password: '',
    confirmPassword: '',
    onRegister: false,
  };

  componentWillReceiveProps(next) {
    if(this.state.onRegister && next.authRegisterPromise.isSuccess){
      this.props.login({
        email: this.state.email,
        password: this.state.password
      });
    }

    this.setState({
      onRegister: next.authRegisterPromise.isPending,
      error: {...next.error}
    })
  }

  static propTypes = {
    submit: PropTypes.func,
    login: PropTypes.func,
    showLogin: PropTypes.func,
  };

  handleChange(e) {
    const {name} = e.target;
    this.setState({
      [name]: e.target.value
    }, () => {
      this.setState({error: {...this.state.error, [name]: ''}})
    });
  }

  handleSubmit() {
    const data = {...this.state};
    const isValid = validationCustomerRegister(data);
    if (isValid.isError) {
      this.setState({...isValid})
    } else {
      this.props.submit({
        email: data.email.trim().toLowerCase(),
        name: data.name,
        lastName: data.lastName,
        phone: data.phone,
        password: data.password.trim(),
        vendorType: 'disable'
      })
    }
  }

  render() {
    const {
      error,
      email,
      password,
      name,
      phone,
      lastName,
      confirmPassword,
    } = this.state;
    return (
      <div className="booking__block">
        <Input
          type="text"
          label="First name"
          placeholder="First name"
          value={name}
          name="name"
          error={error.name}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="text"
          label="Last name"
          placeholder="Last name"
          value={lastName}
          name="lastName"
          error={error.lastName}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="text"
          label="Phone"
          placeholder="Phone"
          value={phone}
          name="phone"
          error={error.phone}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="email"
          label="E-mail address"
          placeholder="Email"
          value={email}
          name="email"
          error={error.email}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="password"
          label="Password"
          placeholder="Password"
          value={password}
          name="password"
          error={error.password}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="password"
          label="Confirm Password"
          placeholder="Password"
          value={confirmPassword}
          name="confirmPassword"
          error={error.confirmPassword}
          onChange={(e) => this.handleChange(e)}
        />
        <Button
          name="Register"
          type={buttonTypes.AUTHENTICATION}
          onClick={() => this.handleSubmit()}
        />
        <p className="booking__link">
          <span>Already have an account?</span>
          <Button
            type={buttonTypes.LINK}
            name="Sign in"
            onClick={this.props.showLogin}
          />
        </p>
      </div>
    )
  }
}

export default Register;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/auth/register.js